
// Estilos
import estilos from './pageWork.module.css';

// Componentes
import Background from "../../elements/backgrounds/background";
import LabelMenu from '../../elements/labels/labelMenu';

// Data
import { TEXT } from "../../../utils/varGlobal";

function PageWork(){
    return (
        <main>
            <Background>
                <LabelMenu opcion='work' goBack={true}/>
                <p id={estilos.text}>
                    {TEXT.work.TEXT.join("\n\n")}
                </p>
            </Background>
        </main>
    )
}

export default PageWork;